import React from 'react';
import type { Icon } from '@phosphor-icons/react';

/**
 * Knöpfe des Immobilienbereichs (README §4.6):
 * 32/36 px (Kopf, Werkzeugleiste), 40 px (Panel-Aktion), 44–48 px (Primär im Formular).
 */
export type KnopfArt = 'akzent' | 'fuellung' | 'glas' | 'ok' | 'bad';
export type KnopfGroesse = 32 | 36 | 40 | 44 | 48;

const ART: Record<KnopfArt, React.CSSProperties> = {
  akzent: { background: 'var(--acc-fill)', color: 'var(--acc-ink)', boxShadow: 'var(--acc-sh)', fontWeight: 800 },
  fuellung: { background: 'var(--fill2)', color: 'var(--ink)', fontWeight: 700 },
  glas: {
    background: 'var(--glass)', color: 'var(--ink)', boxShadow: 'var(--glass-sh)', fontWeight: 600,
    backdropFilter: 'blur(28px) saturate(170%)', WebkitBackdropFilter: 'blur(28px) saturate(170%)',
  },
  ok: { background: 'var(--ok-soft)', color: 'var(--ok)', fontWeight: 700 },
  bad: { background: 'var(--bad-soft)', color: 'var(--bad)', fontWeight: 700 },
};

export interface ImmoButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  art?: KnopfArt;
  groesse?: KnopfGroesse;
  icon?: Icon;
  /** Pille (Radius = Höhe/2) statt abgerundetes Rechteck. */
  pille?: boolean;
  /** Icon um 45° drehen (Plus → Schließen bei Drehkarten). */
  iconGedreht?: boolean;
}

export const ImmoButton = React.forwardRef<HTMLButtonElement, ImmoButtonProps>(function ImmoButton(
  { art = 'fuellung', groesse = 36, icon: IconKomp, pille = true, iconGedreht = false, className = '', style, children, disabled, type = 'button', ...rest },
  ref,
) {
  const schrift = groesse >= 44 ? (groesse === 48 ? 15 : 14) : 13;
  const radius = pille ? groesse / 2 : groesse >= 44 ? (groesse === 48 ? 16 : 14) : 12;
  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled}
      className={`inline-flex items-center justify-center whitespace-nowrap ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'} ${className}`}
      style={{
        height: groesse,
        padding: children ? `0 ${groesse >= 44 ? 20 : 14}px` : 0,
        width: children ? undefined : groesse,
        gap: 7,
        borderRadius: radius,
        border: 'none',
        fontSize: schrift,
        transition: 'background .3s, opacity .2s',
        opacity: disabled ? 0.45 : 1,
        ...ART[art],
        ...style,
      }}
      {...rest}
    >
      {IconKomp && (
        <IconKomp
          weight="bold"
          size={schrift + 1}
          style={{ transition: 'transform .4s', transform: iconGedreht ? 'rotate(45deg)' : 'none', flexShrink: 0 }}
        />
      )}
      {children}
    </button>
  );
});
